import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Lenis from 'lenis';
import { Toaster } from 'sonner';

import Home from './pages/Home';
import About from './pages/About';
import WebDevelopment from './pages/services/WebDevelopment';
import MobileDevelopment from './pages/services/MobileDevelopment';
import SEOMarketing from './pages/services/SEOMarketing';
import UIUXDesign from './pages/services/UIUXDesign';
import Portfolio from './pages/Portfolio';
import Careers from './pages/Careers';
import Internships from './pages/Internships';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import BlogManagement from './pages/admin/BlogManagement';
import ProjectManagement from './pages/admin/ProjectManagement';
import CareerManagement from './pages/admin/CareerManagement';
import InternshipSettings from './pages/admin/InternshipSettings';
import ContactSubmissions from './pages/admin/ContactSubmissions';
import ProtectedRoute from './components/ProtectedRoute';
import JobDetails from './pages/JobDetails';
import AdminApplications from './pages/admin/AdminApplications'
import ScrollToTop from "./components/ScrollToTop";
import UserManagement from "./pages/admin/UserManagement";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/mobile-development" element={<MobileDevelopment />} />
          <Route path="/services/seo-marketing" element={<SEOMarketing />} />
          <Route path="/services/uiux-design" element={<UIUXDesign />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/internships" element={<Internships />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers/:id" element={<JobDetails />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/blog" element={<ProtectedRoute><BlogManagement /></ProtectedRoute>} />
          <Route path="/admin/projects" element={<ProtectedRoute><ProjectManagement /></ProtectedRoute>} />
          <Route path="/admin/careers" element={<ProtectedRoute><CareerManagement /></ProtectedRoute>} />
          <Route path="/admin/internships" element={<ProtectedRoute><InternshipSettings /></ProtectedRoute>} />
          <Route path="/admin/contact" element={<ProtectedRoute><ContactSubmissions /></ProtectedRoute>} />
          <Route path="/admin/applications" element={<ProtectedRoute><AdminApplications /></ProtectedRoute>} />
           <Route path="/admin/usermanagement" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
